import React from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {ActionCreators} from 'redux-undo';
import {DeviceType} from '../../../../../incase-domain/common/DeviceType.enum';
import Button from '../../../../../incase-domain/components/button/Button';
import {setPresentationSettingsModalAction, setSelectedView} from '../../../../../store/actions/presentation';
import {selectedViewSelector} from '../../../../../store/selectors/presentation.selectors';
import {
    isSlideModifiedSelector,
    selectedSlideSelector,
    slideReducerFutureSelector,
    slideReducerPastSelector,
} from '../../../../../store/selectors/slide.selectors';
import {presUpdateSpinnerSelector} from '../../../../../store/selectors/spinner.selector';
import {useRulesModal} from '../../../../context/RulesModalContext';
import {useSlideUpdateContext} from '../../../../context/SetSlideUpdateContext';

function Toolbar(): JSX.Element {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const {openRulesModal} = useRulesModal();

    const {setAndSaveSlide} = useSlideUpdateContext();

    const slide = useSelector(selectedSlideSelector);
    const modified = useSelector(isSlideModifiedSelector);
    const presUpdateSpinner = useSelector(presUpdateSpinnerSelector);

    const slidePast = useSelector(slideReducerPastSelector);
    const slideFuture = useSelector(slideReducerFutureSelector);

    const selectedView = useSelector(selectedViewSelector);

    const mutateOnModified = (cb?: () => void): void => {
        if (modified) {
            setAndSaveSlide(slide, {onSuccess: cb});
        } else cb && cb();
    };

    return (
        <div className="c-toolbar">
            <div className="c-toolbar__group">
                <Button
                    variant="ghost"
                    size="sm"
                    leading="solar:undo-left-round-linear"
                    rounded
                    onClick={() => dispatch(ActionCreators.undo())}
                    disabled={slidePast.length < 1}
                >
                    {t('presEditPage.subNavBar.undo')}
                </Button>
                <Button
                    variant="ghost"
                    size="sm"
                    leading="solar:undo-right-round-linear"
                    rounded
                    onClick={() => dispatch(ActionCreators.redo())}
                    disabled={!(slideFuture.length > 0)}
                >
                    {t('presEditPage.subNavBar.redo')}
                </Button>
                <Button
                    variant="ghost"
                    size="sm"
                    leading="solar:reorder-linear"
                    rounded
                    onClick={() => mutateOnModified(openRulesModal)}
                    disabled={presUpdateSpinner}
                >
                    {t('presEditPage.rules.title')}
                </Button>
            </div>
            <div className="c-toolbar__group">
                <Button
                    variant="ghost"
                    color={selectedView === DeviceType.DESKTOP ? 'secondary' : 'primary'}
                    size="sm"
                    leading="solar:display-linear"
                    rounded
                    disabled={slide?.deviceType === DeviceType.MOBILE}
                    onClick={() => dispatch(setSelectedView(DeviceType.DESKTOP))}
                >
                    {t('presEditPage.subNavBar.desktop')}
                </Button>
                <Button
                    variant="ghost"
                    color={selectedView === DeviceType.MOBILE ? 'secondary' : 'primary'}
                    size="sm"
                    leading="solar:smartphone-linear"
                    rounded
                    disabled={slide?.deviceType === DeviceType.DESKTOP}
                    onClick={() => dispatch(setSelectedView(DeviceType.MOBILE))}
                >
                    {t('presEditPage.subNavBar.mobile')}
                </Button>
            </div>
            <div style={{flex: '1'}} />
            <div className="c-toolbar__group">
                <Button
                    variant="ghost"
                    size="sm"
                    leading="solar:settings-linear"
                    rounded
                    onClick={() => dispatch(dispatch(setPresentationSettingsModalAction(true)))}
                >
                    {t('presEditPage.subNavBar.settings')}
                </Button>
            </div>
        </div>
    );
}

export default Toolbar;
